// extracted by mini-css-extract-plugin
module.exports = {"icon-list":"social-share-icons-m__icon-list__3YA3Q","icon-item":"social-share-icons-m__icon-item__3cyQq"};